
import { useEffect } from "react";

export function useDrawerScrollMargin(
  id?: string,
  active?: boolean,
  defaultMargin: string = "var(--header-bar-size)",
  scrolledMargin: string = "40px"
) {
  useEffect(() => {
    const drawerSelector = id ? ".ant-drawer-open" : ".ant-drawer.ant-drawer-right";
    const drawerEl = document.querySelector<HTMLElement>(drawerSelector);
    const headerEl = document.querySelector("header");
    if (!drawerEl || !active || !headerEl) return;

    const applyMargin = () => {
      const hasSlimmer = headerEl.classList.contains("slimmer");
      drawerEl.style.marginTop = hasSlimmer ? scrolledMargin : defaultMargin;
    };

    applyMargin();

    return () => {
      drawerEl.style.marginTop = defaultMargin; // reset on cleanup
    };
  }, [id, active, defaultMargin, scrolledMargin]);
}
